import copy from "copy-to-clipboard";

const copyToClipboard = (content: string) => copy(content);

export {
  copyToClipboard,
};